<template>
  <div class="question-nav">
    <div
      :class="
        `question-nav__header-wrapper ${
          showQuestions
            ? 'question-nav__header-wrapper--open'
            : 'question-nav__header-wrapper--close'
        }`
      "
    >
      <h5 class="question-nav__title">
        Summary
      </h5>
    </div>
    <div class="question-nav__wrapper" v-if="showQuestions">
      <div class="question-nav__questions__title">Questions</div>
      <div class="question-nav__questions">
        <span
          :class="questionClasses(index, question)"
          v-for="(question, index) in questions"
          :key="question.uuid || question.question_id"
          @click="$emit('move-to-question', index)"
        ></span>
      </div>
      <div class="question-nav__info">
        <span
          class="question-nav__info__bullet question-nav__info__bullet--answered"
        ></span>
        Answered
      </div>
      <div class="question-nav__info">
        <span class="question-nav__info__bullet"></span> Unanswered
      </div>
      <div class="question-nav__info">
        <span
          class="question-nav__info__bullet  question-nav__info__bullet--flagged"
        ></span>
        Flagged
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QuestionNavigation',
  props: {
    questions: {
      type: Array,
      required: true,
    },
    currentPosition: {
      type: Number,
      required: true,
    },
  },
  data: () => {
    return {
      showQuestions: true,
    }
  },
  methods: {
    questionClasses(index, question) {
      return {
        'question-nav__question': true,
        'question-nav__question--answered': question.answered,
        'question-nav__question--selected': index === this.currentPosition,
        'question-nav__question--flagged': question.is_flagged,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.question-nav {
  $this: &;
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  border-radius: 10px;
  border-radius: 9px;
  padding: 20px 25px;
  &__questions {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    margin-top: 10px;
    &__title {
      font-size: rem(16px);
    }
  }
  &__title {
    margin: 0;
    font-size: rem(24px);
    line-height: 32px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--tundora-gray);
    margin-bottom: 30px;
  }
  &__question {
    width: 18px;
    height: 18px;
    border: 2px solid var(--dove-gray);
    border-radius: 28px;
    opacity: 1;
    cursor: pointer;
    margin: 2px;
    font: normal normal normal 16px/32px var(--font-medium);
    &--answered {
      background: var(--dove-gray) 0% 0% no-repeat padding-box;
    }
    &--selected {
      border: 2px solid var(--cornflower-blue);
    }
    &--flagged {
      border: none;
      background: var(--orange) 0% 0% no-repeat padding-box;
    }
  }
  &__info {
    display: flex;
    align-items: center;
    &__bullet {
      width: 17px;
      height: 17px;
      border-radius: 8px;
      display: inline-block;
      margin: 0 10px 0 0;
      border: 2px solid var(--dove-gray);
      &--answered {
        border: none;
        background: var(--dove-gray) 0% 0% no-repeat padding-box;
      }
      &--selected {
        border: 4px solid var(--cornflower-blue);
      }
      &--flagged {
        border: none;
        background: linear-gradient(
          92.23deg,
          #ef7d22 3.65%,
          #ef741d 25.47%,
          #ee5a10 62.46%,
          #ee3b00 98.5%
        );
      }
    }
    margin-bottom: 10px;
    width: 100%;
    flex: 1;
  }
}
</style>
